import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MarketingService } from 'src/app/services/marketing/marketing.service';

@Component({
    selector: 'xlog-marketing-container',
    templateUrl: './marketing-container.component.pug',
    styleUrls: ['./marketing-container.component.scss'],
    standalone: false
})
export class MarketingContainerComponent implements OnInit {
    @Input() isClassic = true;
    route: ActivatedRouteSnapshot;

    constructor(
        public marketing: MarketingService
    ) {}

    ngOnInit() {
        this.marketing.isClassic = this.isClassic;
        this.marketing.getMarketingAnnouncement();
    }
}
